<script setup lang="ts">
import type {Dashboard} from "@/laboratory/components/dashboard/dashboard";
import LaboratoryWidget from "@/laboratory/components/dashboard/components/LaboratoryWidget.vue";

defineProps<{
    dashboard: Dashboard;
    laboratoryId: string | number;
}>();
</script>

<template>
  <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
    <LaboratoryWidget
      v-for="(widget) in dashboard.widgets"
      :key="widget.id"
      :laboratory-id="laboratoryId"
      :widget="widget"
      :class="`md:col-span-${widget.layout.col_span}`"
    />
  </div>
</template>

<style scoped>

</style>
